module.exports = __webpack_public_path__ + "img/60ba8f2.jpg";